<button type="button" class="chip" [ngClass]="Type" [class.active]="Selected" (click)="clicked()">
    <i *ngIf="Type==='Assist'" class="mr-2" [ngClass]="AssistIcon"></i>
    {{Label}}
    <i *ngIf="Type==='Filter' && Selected===true" class="fas fa-check ml-2"></i>
</button>